import { page } from '$app/state';
import { ShoppingCart } from '$lib/state/shoppingCart.svelte';
import type { SbLink } from '$lib/storyblok/types';

export function getSbUrl(
	link?: SbLink,
	searchParams?: URLSearchParams,
	pageUrl = page.url
): string {
	if (!link) return '#';

	const { cached_url, url, linktype } = link;

	if (linktype === 'url' && url.startsWith('http')) {
		return url;
	}

	const baseUrl =
		cached_url.startsWith('?') || cached_url.startsWith('/')
			? cached_url
			: `/${cached_url}`.replace(/\/$/, '');

	const targetUrl = new URL(
		baseUrl,
		baseUrl.startsWith('/') ? pageUrl.origin : pageUrl.origin + pageUrl.pathname
	);

	pageUrl.searchParams.forEach((value, key) => {
		if (
			!['newsletter', 'quiz', ShoppingCart.CART_PARAM].includes(key) &&
			!targetUrl.searchParams.has(key)
		) {
			targetUrl.searchParams.append(key, value);
		}
	});

	searchParams?.forEach((value, key) => {
		if (targetUrl.searchParams.has(key)) {
			targetUrl.searchParams.set(key, value);
		} else {
			targetUrl.searchParams.append(key, value);
		}
	});

	return `${targetUrl.pathname}${targetUrl.search}${link.anchor ? `#${link.anchor}` : ''}`;
}
